/* Erotokritos — sidebar nav, search overlay, size-guide modal, quantity stepper */
(function () {
  'use strict';

  var d = document;

  function on(el, evt, fn) {
    if (el) el.addEventListener(evt, fn);
  }

  /* ---------------------------------------------------------------------
     Sidebar nav: submenu disclosure + mobile drawer
     --------------------------------------------------------------------- */
  function initNav() {
    var nav = d.querySelector('[data-ero-nav]');
    if (!nav) return;

    // The theme editor can re-run init(), and older versions of this theme
    // also loaded this script twice. Guard the nav so one click only toggles
    // the submenu once.
    if (nav.getAttribute('data-ero-nav-bound') === 'true') return;
    nav.setAttribute('data-ero-nav-bound', 'true');

    // Submenu toggles — accordion behaviour: only one top-level group open.
    nav.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ero-nav-toggle]');
      if (!btn || !nav.contains(btn)) return;
      e.preventDefault();

      var item = btn.closest('.ero-nav__item');
      if (!item) return;

      var willOpen = !item.classList.contains('is-open');

      if (willOpen) {
        var siblings = nav.querySelectorAll('.ero-nav__list > .ero-nav__item.is-open');
        siblings.forEach(function (sibling) {
          if (sibling === item) return;
          sibling.classList.remove('is-open');
          var siblingBtn = sibling.querySelector(':scope > [data-ero-nav-toggle], :scope > .ero-nav__row [data-ero-nav-toggle]');
          if (siblingBtn) siblingBtn.setAttribute('aria-expanded', 'false');
        });
      }

      item.classList.toggle('is-open', willOpen);
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });

    // Mobile drawer
    var burger = d.querySelector('[data-ero-burger]');
    var scrim = d.querySelector('[data-ero-nav-scrim]');

    function setDrawer(open) {
      nav.classList.toggle('is-open', open);
      if (scrim) scrim.classList.toggle('is-open', open);
      if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      d.documentElement.style.overflow = open ? 'hidden' : '';
    }

    on(burger, 'click', function () {
      setDrawer(!nav.classList.contains('is-open'));
    });
    on(scrim, 'click', function () {
      setDrawer(false);
    });
    on(d, 'keydown', function (e) {
      if (e.key === 'Escape') setDrawer(false);
    });
  }

  /* ---------------------------------------------------------------------
     Wishlist placement: desktop in header, mobile inside the drawer utility row
     --------------------------------------------------------------------- */
  function initWishlistPlacement() {
    var desktopSlot = d.querySelector('[data-ero-wishlist-desktop-slot]');
    var mobileSlot = d.querySelector('[data-ero-wishlist-mobile-slot]');
    if (!desktopSlot || !mobileSlot) return;

    function sync() {
      var wishlist = d.querySelector('.ero-header__wishlist-app');
      if (!wishlist) return;

      if (window.matchMedia('(max-width: 989px)').matches) {
        if (wishlist.parentNode !== mobileSlot) mobileSlot.appendChild(wishlist);
      } else {
        if (wishlist.parentNode !== desktopSlot) desktopSlot.appendChild(wishlist);
      }
    }

    sync();
    window.addEventListener('resize', sync);

    // Some app blocks finish hydrating after the theme scripts. Re-check once
    // their DOM is injected so the same live wishlist control is moved rather
    // than replaced with a hard-coded link.
    var observer = new MutationObserver(function () {
      sync();
    });
    observer.observe(desktopSlot, { childList: true, subtree: true });

    // The app's own header control can render differently on mobile. Keep a
    // stable text label in the drawer and proxy its click to the live app
    // control so Wishlist is always visible beside Log in.
    on(d, 'click', function (e) {
      var trigger = e.target.closest('[data-ero-mobile-wishlist-open]');
      if (!trigger) return;

      var app = d.querySelector('.ero-header__wishlist-app');
      if (!app) return;

      var control = app.querySelector('a, button, [role="button"]');
      if (control && control !== trigger) {
        e.preventDefault();
        control.click();
      }
    });
  }

  /* ---------------------------------------------------------------------
     Search overlay
     --------------------------------------------------------------------- */
  function initSearch() {
    var overlay = d.querySelector('[data-ero-search]');
    if (!overlay) return;
    var openBtns = d.querySelectorAll('[data-ero-search-open]');
    var closeBtn = overlay.querySelector('[data-ero-search-close]');
    var field = overlay.querySelector('input[type="search"], input[name="q"]');

    function setOpen(open) {
      overlay.classList.toggle('is-open', open);
      overlay.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (open && field) field.focus();
    }

    openBtns.forEach(function (openBtn) {
      on(openBtn, 'click', function () {
        setOpen(true);
      });
    });
    on(closeBtn, 'click', function () {
      setOpen(false);
    });
    on(overlay, 'click', function (e) {
      if (e.target === overlay) setOpen(false);
    });
    on(d, 'keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });
  }

  /* ---------------------------------------------------------------------
     Size guide modal
     --------------------------------------------------------------------- */
  function initModal() {
    d.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-ero-modal-open]');
      if (opener) {
        var target = d.getElementById(opener.getAttribute('data-ero-modal-open'));
        if (target) {
          e.preventDefault();
          if (target.tagName === 'DIALOG' && typeof target.showModal === 'function') {
            if (!target.open) target.showModal();
          } else {
            target.classList.add('is-open');
            target.setAttribute('aria-hidden', 'false');
          }
        }
        return;
      }

      if (e.target.tagName === 'DIALOG' && e.target.classList.contains('ero-size-dialog')) {
        if (typeof e.target.close === 'function') e.target.close();
        return;
      }

      var closer = e.target.closest('[data-ero-modal-close]');
      if (closer) {
        var dialog = closer.closest('dialog');
        if (dialog && typeof dialog.close === 'function') {
          dialog.close();
          return;
        }
        var modalFromClose = closer.closest('.ero-modal');
        if (modalFromClose) {
          modalFromClose.classList.remove('is-open');
          modalFromClose.setAttribute('aria-hidden', 'true');
        }
        return;
      }

      var modal = e.target.classList && e.target.classList.contains('ero-modal') ? e.target : null;
      if (modal) {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
      }
    });

    on(d, 'keydown', function (e) {
      if (e.key !== 'Escape') return;
      var openDialog = d.querySelector('dialog.ero-size-dialog[open]');
      if (openDialog && typeof openDialog.close === 'function') {
        openDialog.close();
        return;
      }
      var open = d.querySelector('.ero-modal.is-open');
      if (open) {
        open.classList.remove('is-open');
        open.setAttribute('aria-hidden', 'true');
      }
    });
  }

  /* ---------------------------------------------------------------------
     Quantity stepper — drives Dawn's own quantity input so its change
     events (and therefore cart updates) keep working.
     --------------------------------------------------------------------- */
  function initQty() {
    d.addEventListener('click', function (e) {
      var step = e.target.closest('[data-ero-qty]');
      if (!step) return;
      e.preventDefault();
      var wrap = step.closest('.ero-qty');
      if (!wrap) return;
      var input = wrap.querySelector('input.quantity__input, input[name="quantity"]');
      if (!input) return;

      var min = parseInt(input.getAttribute('min'), 10);
      if (isNaN(min)) min = 1;
      var stepBy = parseInt(input.getAttribute('step'), 10) || 1;
      var current = parseInt(input.value, 10) || min;
      var next = step.getAttribute('data-ero-qty') === 'up' ? current + stepBy : current - stepBy;

      var max = parseInt(input.getAttribute('max'), 10);
      if (next < min) next = min;
      if (!isNaN(max) && next > max) next = max;

      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }


  /* ---------------------------------------------------------------------
     Product information tabs
     --------------------------------------------------------------------- */
  function initProductTabs() {
    d.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-ero-tab]');
      if (!tab) return;
      var tabs = tab.closest('[data-ero-tabs]');
      if (!tabs) return;

      var name = tab.getAttribute('data-ero-tab');
      tabs.querySelectorAll('[data-ero-tab]').forEach(function (item) {
        var active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      tabs.querySelectorAll('[data-ero-panel]').forEach(function (panel) {
        var active = panel.getAttribute('data-ero-panel') === name;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    });
  }

  function init() {
    initNav();
    initWishlistPlacement();
    initSearch();
    initModal();
    initQty();
    initProductTabs();
  }

  if (d.readyState === 'loading') {
    d.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-bind after theme-editor section reloads.
  d.addEventListener('shopify:section:load', init);
})();
